"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var CrudeDialogComponent = function (props) {
    var storeShowDialog = react_redux_1.useSelector(crude_selector_1.getShowDialog);
    var _a = react_1.useState(false), showDialog = _a[0], setShowDialog = _a[1];
    var _b = react_1.useState(props.content), content = _b[0], setContent = _b[1];
    var dialogWidth = props.dialogWidth || 'auto';
    react_1.useEffect(function () {
        setContent(props.content);
    }, [props.content]);
    react_1.useEffect(function () {
        setShowDialog(storeShowDialog);
    }, [storeShowDialog]);
    return (react_1.default.createElement(material_1.Dialog, { onClose: function () { return props.onClose && props.onClose(); }, open: showDialog },
        react_1.default.createElement(material_1.DialogContent, { style: { minWidth: dialogWidth } }, content)));
};
exports.default = CrudeDialogComponent;
